import type { AppPlatformType } from "@lib/dashboardConfig";
import sharedConstants from "@lib/shared_constants.json";

export interface AppleCredentialData {
  id: string;
  valid: boolean;
  bundle_id: string;
  team_id?: string;
  key_id?: string;
  use_development_gateway: boolean;
  certificate_id?: string;
  password?: string;
  expiration?: number;
  type?: string;
}

export interface AppleCredentialDataRequest {
  push_certificate: {
    certificate_id: string;
    jwt_bundle_id: string;
    jwt_key_id: string;
    jwt_team_id: string;
    use_development_gateway: boolean;
    password: string;
  };
}

const providerTypes = sharedConstants.COMMUNICATION.PUSH_PROVIDER_TYPES;

export interface FirebaseCredentialData {
  push_provider_type: typeof providerTypes.FIREBASE;
}

export interface HuaweiCredentialData {
  push_provider_type: typeof providerTypes.HUAWEI;
  huawei_app_secret: string;
  huawei_app_id: string;
}

// Also referred to as ADM / AMZ
export interface KindleCredentialData {
  client_id: string;
  client_secret: string;
}

// Data receive from the server when we request for push credential data on initial load
export type PushCredentialData =
  | AppleCredentialData
  | FirebaseCredentialData
  | HuaweiCredentialData
  | KindleCredentialData;

// Data that is sent to the server when a user saves their request
export type PushCredentialDataRequest =
  | FirebaseCredentialData
  | HuaweiCredentialData
  | KindleCredentialData
  | AppleCredentialDataRequest;

export interface AppsAppIdPushCredentialResult {
  credential?: {
    app_type: AppPlatformType;
    credential_data?: PushCredentialData;
  };
}

export interface PostAppsAppIdPushCredentialProps {
  appId: string;
  data: PushCredentialDataRequest;
}

export interface DeleteAppsAppIdPushCredentialProps {
  appId: string;
}
